.returningUserMessage {
    color: var(--bi-neutral-60);
    text-align: center;
    font: var(--bi-font-body-large);

    @media (width < 768px) {
        font: var(--bi-font-body-small);
    }
}

.buttonContainer {
    width: 100%;
    display: grid;
    gap: var(--bi-scale-3x);
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));

    button {
        width: 100%;
        max-width: 324px;
        justify-self: center;
    }
}

.buttonContainerMultipleButtons {
    @media (width < 768px) {
        grid-template-columns: auto 1fr;

        > button {
            padding-left: var(--bi-scale-3x);
            padding-right: var(--bi-scale-3x);
        }
    }
}

.buttonContainerEqualWidth {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: var(--bi-scale-3x);

    button {
        flex: 1;
    }
}
.userInfo {
    display: flex;
    align-items: center;
    gap: var(--bi-scale-4x);
    flex: 1;

    @media (width < 768px) {
        gap: var(--bi-scale-3x);
    }
}

.userAvatar {
    width: var(--bi-scale-14x);
    height: var(--bi-scale-14x);
}

.userName {
    color: var(--bi-primary-90);
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.125rem;
}
